const TypesChannel = [
    {
        text: "All",
        value: null,
    },
    {
        text: "Web",
        value: 1,
    },
    {
        text: "Call",
        value: 3,
    },
    {
        text: "Rcs",
        value: 2,
    },
];

export default TypesChannel;
